// extracted by mini-css-extract-plugin
export default {"component":"b1SFbC","isAlwaysHorizontalScrollable":"c1SFbC","headline":"d1SFbC","tiles":"e1SFbC","tile":"f1SFbC","by-3":"g1SFbC","by-4":"h1SFbC","by-5":"i1SFbC","type-icon":"j1SFbC"};